import { render, staticRenderFns } from "./StandardSolidButton.vue?vue&type=template&id=6ddeb3ab&scoped=true"
import script from "./StandardSolidButton.vue?vue&type=script&lang=js"
export * from "./StandardSolidButton.vue?vue&type=script&lang=js"
import style0 from "./StandardSolidButton.vue?vue&type=style&index=0&id=6ddeb3ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddeb3ab",
  null
  
)

export default component.exports